import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'zag-form-field',
  imports: [],
  templateUrl: './form-field.html',
  styleUrl: './form-field.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormField {
  // Input properties with signals
  readonly label = input<string>('');
  readonly error = input<string>('');
  readonly hint = input<string>('');
  readonly required = input<boolean>(false);
  readonly forId = input<string | undefined>(undefined);

  /**
   * Derived id for the error/hint element so the projected input can reference
   * it via [attr.aria-describedby]. Convention: pass `forId + '-desc'` as the
   * aria-describedby value on the input inside this form field.
   */
  readonly descId = computed(() => (this.forId() ? `${this.forId()}-desc` : undefined));
}
